/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Col_Coinvestments1Inputs */

const en_coinvestments_insights_col_coinvestments1 = /** @type {(inputs: Coinvestments_Insights_Col_Coinvestments1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-investments`)
};

/**
* | output |
* | --- |
* | "Co-investments" |
*
* @param {Coinvestments_Insights_Col_Coinvestments1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_col_coinvestments1 = /** @type {((inputs?: Coinvestments_Insights_Col_Coinvestments1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Col_Coinvestments1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_col_coinvestments1(inputs)
});
export { coinvestments_insights_col_coinvestments1 as "coInvestments_insights_col_coinvestments" }